import React from "react";
import { mockTeamData } from "../mock/mockData";

const TeamSection = () => {
  return (
    <section className="px-4 md:px-8 mb-20" style={{ maxWidth: '1400px', margin: '0 auto', paddingTop: '52.8px', paddingBottom: 'clamp(32px, 6vw, 52.8px)' }}>
      <div
        className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16 lg:gap-20 xl:gap-24"
      >
        {mockTeamData.map((member, index) => (
          <div key={index} className="flex flex-col w-full max-w-sm mx-auto md:max-w-none md:mx-0">
            {/* Profile Image */}
            <div style={{ marginBottom: '32px' }}>
              <img
                src={member.image}
                alt={`Porträt von ${member.name}`}
                className="w-full aspect-[3/4] object-cover"
                style={{ backgroundColor: '#8B7355' }}
              />
            </div>
            
            {/* Name */}
            <h2 
              className="text-black font-normal"
              style={{
                fontSize: 'clamp(20px, 4vw, 25.6px)',
                lineHeight: '33.55px',
                fontFamily: '"Helvetica Neue", Arial, sans-serif',
                fontWeight: 400,
                marginBottom: '16px',
                marginTop: '0'
              }}
            >
              {member.name}
            </h2>
            
            {/* Description */}
            <p 
              className="text-black font-normal"
              style={{
                fontSize: 'clamp(14px, 3vw, 17.6px)',
                lineHeight: 'clamp(24px, 5vw, 33.44px)',
                fontFamily: '"Helvetica Neue", Arial, sans-serif',
                fontWeight: 400,
                marginBottom: '32px',
                marginTop: '0'
              }}
            >
              {member.description}
            </p>
            
            {/* Links */}
            <div className="flex flex-col">
              <a
                href={member.linkedinUrl}
                className="text-black underline hover:no-underline transition-all duration-200 font-normal"
                style={{
                  fontSize: 'clamp(14px, 3vw, 17.6px)',
                  lineHeight: 'clamp(24px, 5vw, 33.44px)',
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  fontWeight: 400,
                  marginBottom: '0'
                }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Linkedin
              </a>
              
              {member.additionalLink && (
                <a
                  href={member.additionalLink.url}
                  className="text-black underline hover:no-underline transition-all duration-200 font-normal"
                  style={{
                    fontSize: 'clamp(14px, 3vw, 17.6px)',
                    lineHeight: 'clamp(24px, 5vw, 33.44px)',
                    fontFamily: '"Helvetica Neue", Arial, sans-serif',
                    fontWeight: 400,
                    marginBottom: '0'
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {member.additionalLink.text}
                </a>
              )}
              
              <a
                href={member.contactEmail}
                className="text-black underline hover:no-underline transition-all duration-200 font-normal"
                style={{
                  fontSize: 'clamp(14px, 3vw, 17.6px)',
                  lineHeight: 'clamp(24px, 5vw, 33.44px)',
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  fontWeight: 400,
                  marginBottom: '0'
                }}
              >
                Kontaktieren
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;